// extracted by mini-css-extract-plugin
export default {"userLabel":"top-bar_userLabel__n4DKH","topBar":"top-bar_topBar__ccQ1g","topBarHeading":"top-bar_topBarHeading__Ii+7z","logo":"top-bar_logo__bAmss","avatar":"top-bar_avatar__vYm2a"};